import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getRefreshToken, isAuthenticated, renewAccessToken } from "../utils/cloudApi";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const authed = isAuthenticated();
  const canRenew = !authed && Boolean(getRefreshToken());
  const [renewal, setRenewal] = useState({ path: null, failed: false });
  const failedHere = renewal.failed && renewal.path === location.pathname;

  useEffect(() => {
    if (!canRenew || failedHere) return undefined;
    let alive = true;
    renewAccessToken().then((ok) => {
      if (alive) setRenewal({ path: location.pathname, failed: !ok });
    });
    return () => {
      alive = false;
    };
  }, [canRenew, failedHere, location.pathname]);

  if (authed) return children;
  if (canRenew && !failedHere) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-[var(--app-bg)]" role="status" aria-label="Restoring session">
        <span className="h-7 w-7 animate-spin rounded-full border-2 border-slate-400/30 border-t-[#7c8cff]" />
      </div>
    );
  }
  return <Navigate to="/" replace state={{ from: location.pathname }} />;
};

export default ProtectedRoute;
